//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import strategyDetail from './strategyDetail'
import strategyComment from './strategyComment'
export default{
	data() {
		return {
			//swiper轮播图
			indicatorDots: true, //是否显示面板指示点
			white:'#ffffff',
			circular:true, //是否采用衔接滑动
			autoplay: true, //是否自动切换
			interval: 3000, //自动切换时间间隔
			duration: 500, //滑动动画时长
			current:1, //当前所在滑块
			currentLength:0, //图片总数
			imgList:[], //轮播图数组
			//基础内容和头部价格与时间
			id:'',
			detail:{},
			state:'',  //当前对应的攻略栏目（类型 字符串）1官方推荐 2官方游记 3游客分享
			// officialAvatar: require('@/static/officialAvatar.jpg'), //官方的头像
			//详情tab栏
			titleList:[
				{
					name:'攻略详情',
					code:'1'
				},
				{
					name:'游客评论',
					code:'2'
				}
			],
			status:'1',
			// 日程
			schedule: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五'],
			scenicSpotList:[],
			scenicspotIds:[],
			urlList:{ //详情的接口
				'1':'/weChat/cms/officialtravel/queryById', //官方推荐
				'2':'/weChat/cms/officialstrategy/queryById', //官方游记
				'3':'/weChat/cms/touriststrategy/queryById' //游客分享
			}
		}
	},
	components: {strategyDetail,strategyComment},
	computed: {
		//顶部头像
		// headerImg () {
		// 	return this.state === '1' ? this.officialAvatar : this.detail.headImage
		// },
		//几日游
		days () {
			if (parseFloat(this.detail.severalDays) === 0.5) {
				return '半'
			} else {
				return this.schedule[(this.detail.severalDays - 1)]
			}
		}
	},
	onLoad(event) {
		this.id = event.id
		this.state = event.state
		if(this.state !== '2'){
			this.scenic()
		}
		this.queryData()
	},
	methods: {
		//查询所有的景区
		scenic(){
			let _this = this
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/scenicspot/querylistGroupbyRegionCode',
				data: {}
			}).then(res=>{
				_this.scenicSpotList = res.data
				let scenicspotArray = []
				let scenicspotIds = _this.detail.scenicspotIds.split(',')
				if(scenicspotIds){
					scenicspotIds.forEach(t=>{
						_this.scenicSpotList.forEach((tt,ii)=>{
							if(tt.value){
								tt.value.forEach(ttt=>{
									if(ttt.id===t){
										scenicspotArray.push(ttt.name)
									}
								})
							}
						})
					})
				}
				_this.scenicspotIds = scenicspotArray
			})
		},
		//列表
		queryData() {
			let _this = this
			let url = this.state?this.state:'1'
			this.$ajax({
				method:'post',
				url:_this.urlList[url],
				data:{
					id:_this.id
				}
			}).then(res=>{
				if(url==='2'){
					_this.detail = res.data[0]
					_this.imgList=res.data[0].coverImagesUrl.split(',')
					_this.currentLength=_this.imgList.length
				} else{
					_this.detail = res.data
					_this.imgList=res.data.coverImagesUrl.split(',')
					_this.currentLength=_this.imgList.length
				}
			})
		},
		//tab列表选择
		active(val){
			this.status = val.code
		},
		//发布时间
		date () {
		    let date = new Date(this.detail.pushTime)
		    let minu = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			 return date.getMonth() + 1 + '月' + date.getDate() + '日'
		    // return date.getMonth() + 1 + '月' + date.getDate() + '日' + ' ' + date.getHours() + ':' + minu
		},
		//顶部轮播图当前图片页数
        changeImg(event){
            this.current=event.detail.current+1
        },
	},
}
